<template>
  <div class="mask" @mouseenter="showBtn=true" @mouseleave="showBtn=false">
    <div class="btn-box" v-if="showBtn">
      <el-button
        class="btn move"
        :class="`${btnStyle.up?'':'dis'}`"
        :disabled="!btnStyle.up"
        @click="up"
      >上移</el-button>
      <el-button
        class="btn move"
        :class="`${btnStyle.down?'':'dis'}`"
        :disabled="!btnStyle.down"
        @click="down"
      >下移</el-button>
      <el-button
        class="btn edit"
        :class="`${btnStyle.edit?'':'dis'}`"
        :disabled="!btnStyle.edit"
        @click="edit"
      >编辑</el-button>
      <el-button
        class="btn del"
        :class="`${btnStyle.del?'':'dis'}`"
        :disabled="!btnStyle.del"
        @click="del"
      >删除</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'maskBtnGroup',
  props: {
    idx: [String, Number],
    info: Object,
    moduleLength: [String, Number],
    hasRecommend: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnStyle: (vm) => {
      let style = {
        up: true,
        down: true,
        edit: true,
        del: true,
      };
      // 头部底部不能删除不能移动
      if (vm.idx == 'nav_module' || vm.idx == 'head_module') {
        style.up = false;
        style.down = false;
        style.del = false;
      }
      // 只有拼多多京东以及拼图模块可以编辑
      if (
        vm.info.moduleType == 'pit-module' &&
        vm.info.module != 'pdd_module' &&
        vm.info.module != 'jd_module'
      ) {
        style.edit = false;
      }
      //  为你推荐模块不可移动
      if (vm.info.module == 'command_module') {
        style.up = false;
        style.down = false;
      }
      //  列表最顶部不能上移，最底部不能下移
      if (vm.idx == vm.moduleLength - 1) {
        style.down = false;
      }
      //  第一个不能上移
      if (vm.idx == 0) {
        style.up = false;
      }
      //  下一个是为你推荐则不能下移
      if (vm.idx == vm.moduleLength - 2 && vm.hasRecommend) {
        style.down = false;
      }
      return style;
    },
  },
  data: () => ({
    showBtn: false,
  }),
  methods: {
    up() {
      this.$emit('moveUp');
    },
    down() {
      this.$emit('moveDown');
    },
    edit() {
      this.$emit('edit');
    },
    del() {
      this.$emit('del');
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  transition: all 0.2s;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  &:hover {
    background: rgba(0, 0, 0, 0.24);
  }
  /deep/ .el-button {
    width: 56px;
    height: 36px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(141, 146, 153, 1);
    color: #46494d;
    padding: 0px;
    &:hover {
      color: #fff;
    }
  }
  .btn-box {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    white-space: nowrap;
  }
  .btn {
    transition: all 0.2s;
    margin-right: 8px;
    &:last-child {
      margin-right: 0px;
    }
  }
  .move {
    &:hover {
      background: #3ac282;
      border: 1px solid #3ac282;
    }
  }
  .edit {
    &:hover {
      background: $theme;
      border: 1px solid $theme;
    }
  }
  .del {
    &:hover {
      background: #fe4242;
      border: 1px solid #fe4242;
    }
  }
  .dis {
    color: #8d9299;
    background: #c1c9d2;
    border-radius: 2px;
    border: none;
    &:hover {
      color: #8d9299;
      background: #c1c9d2;
      border: none;
    }
  }
}
</style>